import { formatDate } from '@angular/common';
import {
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DIALOG_DATA, getFormattedDate } from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { JobsService } from '../../../../pages/pages/jobs/jobs.service';
import { UsersService } from '../../../../pages/pages/users/users.service';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { ToasterService } from '../../../services/toaster.service';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { DialogRef } from '../../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../../modal-dialogue/modal-dialogue.service';
import { MediaPreviewComponent } from '../../media-preview/media-preview.component';

@Component({
  selector: 'gtapp-add-edit-identification',
  templateUrl: './add-edit-identification.component.html',
  styleUrl: './add-edit-identification.component.scss',
  standalone: false,
})
export class AddEditIdentificationComponent implements OnInit {
  validDate = getFormattedDate(new Date());
  @Input() identificationForm: UntypedFormGroup = new UntypedFormGroup({
    issuer_state: new UntypedFormControl(''),
    licence_class: new UntypedFormControl(null),
    id_number: new UntypedFormControl(null, [Validators.required]),
    valid_till: new UntypedFormControl(this.validDate, [Validators.required]),
    id_type: new UntypedFormControl('', [Validators.required]),
    assignee_id: new UntypedFormControl(null),
    photos: new UntypedFormControl([]),
    issue_date: new UntypedFormControl(this.validDate),
  });
  stateData: any = [];
  stateDataBackupList: any = [];

  licenseClassBackupData: any = [];
  licenceClassFilterBackupData: any = [];
  licenseClassData: any = [];

  credentialTypesBackupData: any[] = [];
  credentialTypeList: any = [];

  identificationState: any;

  @Input() showFrom: string = 'profilePage';
  @Input() subContractorId: string = '';

  // edit purpose prefil fields
  licenseClassName: string = '';
  issuerStateName: string = '';
  selectedIdentification: any;

  // managing identifications of users by manager

  selectedAssignee: any = {};
  assigneeList: any = [];
  assigneeListBackupData: any = [];

  focusedFieldDict: any = {};
  selectedCredentialTypeSuggestionId: number = 0;

  totalFileSize: number = 0;

  initialFormValue: any;
  hasFormValuesChanged: boolean = false;

  imageContainerCheck: any = {};

  constructor(
    @Optional() protected dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private appService: AppService,
    private viewContainterRef: ViewContainerRef,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
  ) {}
  ngOnInit(): void {
    this.getStates(1);
    if (this.dialogueData) {
      this.identificationState = this.dialogueData?.licenseState;
      this.showFrom = this.dialogueData?.showFrom || this.showFrom;
      this.subContractorId =
        this.dialogueData?.subContractorId || this.subContractorId;
      this.selectedIdentification =
        this.dialogueData?.selectedIdentification || {};
      if (this.selectedIdentification?.id) {
        this.formatSelectedIdentification();
      }
    }
    if (!this.identificationForm.value?.issuer_state)
      this.focusedFieldDict.stateFieldFocused = true;
    if (!this.identificationForm.value?.licence_class)
      this.focusedFieldDict.licClassField = true;

    if (
      this.showFrom === 'manageIdentificationPage' &&
      !this.selectedIdentification?.id
    ) {
      this.getAssignees();

      this.identificationForm.controls['assignee_id'].setValidators([
        Validators.required,
      ]);
      if (this.dialogueData?.selectedUser?.id) {
        this.selectedAssignee = this.dialogueData?.selectedUser;
        this.identificationForm.controls['assignee_id'].setValue(
          this.dialogueData?.selectedUser?.id,
        );
      } else {
        this.focusElement('assigneeInputField');
      }
    }
  }
  formatSelectedIdentification() {
    this.hasFormValuesChanged = false;
    const selectedIdentitification = JSON.parse(
      JSON.stringify(this.selectedIdentification),
    );
    this.identificationForm.patchValue(selectedIdentitification);

    if (!this.identificationForm.value?.valid_till) {
      this.identificationForm.controls['valid_till'].disable();
      this.identificationForm.controls['valid_till'].removeValidators([
        Validators.required,
      ]);
      this.identificationForm.controls['valid_till'].setValue(null);

      this.identificationForm.controls['valid_till'].updateValueAndValidity();
    }
    this.licenseClassName = this.selectedIdentification?.licence_class;
    this.issuerStateName = this.selectedIdentification?.issuer_state;

    this.initialFormValue = JSON.parse(
      JSON.stringify(this.identificationForm.value),
    );
    this.onImageContainerCheck();

    this.identificationForm?.valueChanges.subscribe((val) => {
      this.hasFormValuesChanged =
        JSON.stringify(val) !== JSON.stringify(this.initialFormValue);
    });
  }
  filterLicenceClasses() {
    this.licenseClassData = this.licenseClassBackupData?.filter(
      (licClass: any) => {
        const combinations = licClass?.conditions?.filter_combination ?? [];

        if (!combinations?.length) return true;

        return combinations?.some(([credId, state]: [any, any]) => {
          const credMatch =
            !credId || credId === this.selectedCredentialTypeSuggestionId;
          const stateMatch =
            !this.issuerStateName ||
            state?.toLowerCase() === this.issuerStateName.toLowerCase();

          return credMatch && stateMatch;
        });
      },
    );

    this.licenceClassFilterBackupData = JSON.parse(
      JSON.stringify(this.licenseClassData),
    );
  }
  getStates(countryId: any) {
    this.appService
      .getStates(+countryId, { unique_state_names: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          let stateDataList: any = [];
          response?.data?.forEach((state: any) => {
            stateDataList.push(state?.code);
          });
          this.credentialTypeList = response?.credential_types;

          this.credentialTypesBackupData = JSON.parse(
            JSON.stringify(this.credentialTypeList || []),
          );
          if (!this.selectedIdentification?.id) {
            this.focusedFieldDict.credentialTypeFieldFocused = true;
            if (this.showFrom != 'manageIdentificationPage')
              this.editField('id_type');
          }
          this.licenseClassBackupData = JSON.parse(
            JSON.stringify(response?.licence_classes || []),
          );
          this.filterLicenceClasses();

          response?.unique_state_names?.forEach((state: any) =>
            this.stateData.push({ name: state }),
          );

          this.stateDataBackupList = JSON.parse(
            JSON.stringify(this.stateData || []),
          );

          if (this.identificationState) {
            const selectedState = this.stateData.find(
              (item: any) =>
                item?.name?.toLowerCase() ===
                this.identificationState.toLowerCase(),
            );
            if (selectedState) {
              this.onStateSelect(selectedState);
            }
          }
        }
      });
  }
  onLicenceClassSearch(event: any) {
    this.identificationForm.controls['licence_class'].setValue(
      event?.target?.value,
    );
    const searchStr = event?.target?.value?.toLowerCase();
    this.licenseClassName = event?.target?.value;
    this.licenseClassData = this.licenceClassFilterBackupData?.filter(
      (item: any) =>
        item?.name_upper?.toLowerCase().includes(searchStr?.toLowerCase()),
    );
  }
  onlicenseSelect(data: any) {
    if (data) {
      this.licenseClassName = data?.name_upper;

      this.identificationForm.controls['licence_class'].setValue(
        this.licenseClassName,
      );
    } else {
      this.identificationForm.controls['licence_class'].setValue(
        this.licenseClassName,
      );
    }
  }
  onStateSearch(event: any) {
    this.issuerStateName = event?.target?.value;

    this.identificationForm.controls['issuer_state'].setValue(
      this.issuerStateName,
    );
    const searchStr = this.issuerStateName?.toLowerCase();
    this.stateData = this.stateDataBackupList?.filter((state: any) =>
      state?.name?.toLowerCase()?.includes(searchStr),
    );
    this.filterLicenceClasses();
  }
  onStateSelect(data: any) {
    this.identificationForm.controls['issuer_state'].setValue(data?.name);
    this.issuerStateName = data?.name;
    this.licenseClassData = this.licenseClassBackupData.filter((item: any) =>
      item?.state?.toLowerCase()?.includes(this.issuerStateName?.toLowerCase()),
    );
    this.focusElement('licClassField');
    this.filterLicenceClasses();
  }
  getFormattedFileData() {
    let fileData: FormData = new FormData();

    Object.entries(this.identificationForm.value).forEach(([key, value]) => {
      if (value) {
        if (key == 'photos') {
          if (value as any) {
            const uploadFiles: any = value || [];
            const fileIdsPresent: any = [];
            for (const item of uploadFiles) {
              const file: any = item;
              if (file?.file) {
                fileData.append(file?.file_number, file?.file);
              } else if (file?.id) {
                // file is already in the db
                fileIdsPresent.push(file?.id);
              }

              if (fileIdsPresent?.length)
                fileData.append(key, JSON.stringify(fileIdsPresent));
            }
          }
        } else {
          fileData.append(key, value as any);
        }
      }
    });
    return fileData;
  }
  updateIdentification() {
    if (this.identificationForm.valid && this.selectedIdentification?.id) {
      this.spinnerService.show();

      this.updateDateFields();
      const fileData = this.getFormattedFileData();
      this.appService
        .formDataApi(
          `credential/${this.selectedIdentification?.id}`,
          fileData,
          false,
          {
            replace_credentials: 1,
            credential_owner:
              this.showFrom === 'companyProfilePage'
                ? 'subscriber'
                : this.showFrom === 'subContractorPage'
                  ? 'sub_contractor'
                  : 'user',
            from_manage_cred_page:
              this.showFrom == 'manageIdentificationPage' ? 1 : 0,
          },
          'PUT',
        )
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });

            this.closeDialogue(
              this.showFrom == 'manageIdentificationPage'
                ? true
                : response?.data || [],
            );
            this.identificationForm.reset();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: 'invalid data',
        successMessage: '',
      });
    }
  }
  closeDialogue(data: any) {
    this.dialogRef.close(data);
  }

  addIdentification() {
    if (this.identificationForm.valid) {
      this.spinnerService.show();

      this.updateDateFields();
      let fileData: FormData = new FormData();

      Object.entries(this.identificationForm.value).forEach(([key, value]) => {
        if (value) {
          if (key == 'photos') {
            if (value as any) {
              const uploadFiles: any = value || [];
              for (const item of uploadFiles) {
                const file: any = item;
                if (file?.file) {
                  fileData.append(file?.file_number, file?.file);
                }
              }
            }
          } else {
            fileData.append(key, value as any);
          }
        }
      });
      let reqParams: any = {
        credential_owner:
          this.showFrom === 'companyProfilePage'
            ? 'subscriber'
            : this.showFrom === 'subContractorPage'
              ? 'sub_contractor'
              : 'user',
        from_manage_cred_page:
          this.showFrom == 'manageIdentificationPage' ? 1 : 0,
      };
      if (this.subContractorId) {
        reqParams.sub_contractor_id = btoa(this.subContractorId);
      }

      this.appService
        .formDataApi(`credential`, fileData, false, reqParams)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });

            this.closeDialogue(
              this.showFrom == 'manageIdentificationPage'
                ? true
                : response?.data || [],
            );
            this.identificationForm.reset();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: 'Invalid data',
        successMessage: '',
      });
    }
  }

  selectDeselectSingleAssignee(assigneeData: any) {
    this.selectedAssignee = assigneeData;
    this.identificationForm.controls['assignee_id'].setValue(assigneeData?.id);
  }
  getAssignees(params?: any) {
    const reqParams = params || {};

    this.jobService.getUserList(reqParams).subscribe(async (response: any) => {
      if (response['status'] == 'success') {
        const paramsPresent = params && Object.keys(params)?.length;

        if (!paramsPresent) {
          this.assigneeListBackupData = JSON.parse(
            JSON.stringify(response?.data),
          );
        }

        setTimeout(() => {
          this.assigneeList = JSON.parse(JSON.stringify(response?.data));
        }, 50);
      }
    });
  }
  searchAssignee(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.updateInitialDataList('assignee_id');
    }
  }

  deleteIdentification(credential: any) {
    let dialogMsg = 'Archive identification?';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Archive ID',
        btn2Detail: { text: 'Archive', class: 'btn-danger' },
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        let params: any = {
          archive: 1,
          credential_owner:
            this.showFrom === 'companyProfilePage'
              ? 'subscriber'
              : this.showFrom === 'subContractorPage'
                ? 'sub_contractor'
                : 'user',
          from_manage_cred_page:
            this.showFrom == 'manageIdentificationPage' ? 1 : 0,
        };
        this.spinnerService.show();
        this.userService
          .updateIdentification(credential?.id, {}, params)
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.closeDialogue(true);
              this.identificationForm.reset();
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    });
  }

  onSearchIdentificationType(event: any) {
    this.selectedCredentialTypeSuggestionId = 0;
    this.identificationForm.controls['id_type'].setValue(event.target.value);
    if (event.target.value.length) {
      this.credentialTypeList = this.credentialTypesBackupData?.filter(
        (type: any) =>
          type?.name_upper
            ?.toLowerCase()
            ?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.credentialTypeList = this.credentialTypesBackupData || [];
    }
  }
  onSelectIdentificationType(event: any) {
    this.identificationForm.controls['id_type'].setValue(event?.name_upper);
    this.selectedCredentialTypeSuggestionId = event?.id;
    this.focusElement('stateField');
    this.filterLicenceClasses();
  }
  editField(field: string) {
    this.identificationForm.controls[field].setValue('');
    if (field === 'assignee_id') {
      this.selectedAssignee = null;
    }
    this.filterLicenceClasses();
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    setTimeout(() => {
      if (field === 'id_type') {
        this.credentialTypeList = JSON.parse(
          JSON.stringify(this.credentialTypesBackupData || []),
        );
        this.focusElement('licTypeField');
      }
      if (field === 'issuer_state') {
        this.stateData = JSON.parse(
          JSON.stringify(this.stateDataBackupList || []),
        );
        this.issuerStateName = '';
        this.focusElement('stateField');
      }
      if (field === 'licence_class') {
        this.licenseClassData = JSON.parse(
          JSON.stringify(this.licenseClassBackupData || []),
        );
        this.licenseClassName = '';
        this.focusElement('licClassField');
      }
      if (field === 'assignee_id') {
        this.focusElement('assigneeInputField');
        this.assigneeList = JSON.parse(
          JSON.stringify(this.assigneeListBackupData || []),
        );
      }
    }, 200);
  }
  focusElement(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, 100);
  }
  dateFieldPresentCheck(event: any, field = 'valid_till') {
    const isChecked =
      field == 'valid_till' ? event.target.checked : !event.target.checked;

    if (this.identificationForm.value[field]) {
      sessionStorage.setItem(
        btoa(`lic_${field}`),
        this.identificationForm.value[field],
      );
    }

    if (isChecked) {
      this.identificationForm.controls[field].disable();
      this.identificationForm.controls[field].removeValidators([
        Validators.required,
      ]);
      this.identificationForm.controls[field].setValue(null);
    } else {
      const savedDate = sessionStorage.getItem(btoa(`lic_${field}`));

      this.identificationForm.controls[field].setValidators([
        Validators.required,
      ]);
      this.identificationForm.controls[field].setValue(
        getFormattedDate(savedDate),
      );
      this.identificationForm.controls[field].enable();
    }
    this.identificationForm.controls[field].updateValueAndValidity();
  }
  uploadIdentificationFile(fileNumber: number) {
    const dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'credentialPhoto' },
    });

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.identificationForm.value.photos.push({
          file: value?.actualFileUpload,
          file_url: value?.fileUrl,
          file_number: fileNumber,
        });
        this.identificationForm.controls['photos'].setValue(
          this.identificationForm.value.photos,
        );
        this.totalFileSize = 0;
        this.identificationForm.value.photos?.forEach(
          (file: any) => (this.totalFileSize += file?.file?.size),
        );

        this.totalFileSize = this.totalFileSize / (1024 * 1024);
        if (this.totalFileSize > 8) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'File size too large',
          });
          this.identificationForm.value.photos = [];
        }
        this.onImageContainerCheck();
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'Unable to access your camera',
        });
      }
    });
  }
  normalizeExistingPhotos(photos: any[]) {
    if (!photos || photos?.length === 0) return photos;

    const allSame = photos?.every(
      (p) => p.file_number === photos[0].file_number,
    );

    const backendBroken = photos?.length > 1 && allSame;

    if (!backendBroken) {
      return photos;
    }

    return photos?.map((photo, index) => ({
      ...photo,
      file_number: index + 1,
    }));
  }

  onImageContainerCheck() {
    this.imageContainerCheck = {};

    this.identificationForm.value.photos = this.normalizeExistingPhotos(
      this.identificationForm.value.photos,
    );

    this.identificationForm.value.photos?.forEach(
      (photo: any, index: number) => {
        if (photo?.file_number == 1) this.imageContainerCheck[1] = photo;
        if (photo?.file_number == 2) this.imageContainerCheck[2] = photo;
      },
    );
  }
  updateDateFields() {
    if (this.identificationForm.value.valid_till)
      this.identificationForm.value.valid_till = formatDate(
        this.identificationForm.value.valid_till,
        'yyyy-MM-dd',
        'en',
      );
    if (this.identificationForm.value.issue_date)
      this.identificationForm.value.issue_date = formatDate(
        this.identificationForm.value.issue_date,
        'yyyy-MM-dd',
        'en',
      );
  }
  deletePhoto(photInfo: any, index: number) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Photo',
        message: 'WARNING: THIS ACTION CANNOT BE UNDONE',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });

    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.identificationForm.value.photos =
          this.identificationForm.value.photos?.filter(
            (photo: any) => photo?.file_number != index,
          );
        this.identificationForm.controls['photos'].setValue(
          this.identificationForm.value.photos,
        );

        this.totalFileSize = 0;
        this.identificationForm.value.photos?.forEach(
          (file: any) => (this.totalFileSize += file?.file?.size || 0),
        );

        this.totalFileSize = this.totalFileSize / (1024 * 1024);
        this.onImageContainerCheck();

        if (!photInfo?.id) return;
        this.spinnerService.show('Removing Photo');
        this.updateDateFields();
        const fileData = this.getFormattedFileData();
        this.appService
          .formDataApi(
            `credential/${this.selectedIdentification?.id}`,
            fileData,
            false,
            {
              replace_credentials: 1,
              credential_owner:
                this.showFrom === 'companyProfilePage'
                  ? 'subscriber'
                  : this.showFrom === 'subContractorPage'
                    ? 'sub_contractor'
                    : 'user',
              from_manage_cred_page:
                this.showFrom == 'manageIdentificationPage' ? 1 : 0,
            },
            'PUT',
          )
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.spinnerService.hide();
              this.selectedIdentification = response?.data;

              this.formatSelectedIdentification();
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                errorMessage: response['message'],
                successMessage: '',
              });
            }
          });
      }
    });
  }
  onOpenFile(file: any) {
    this.dialogService.open(
      MediaPreviewComponent,
      {
        data: { mediaSrc: file?.file_url },
      },
      this.viewContainterRef,
    );
  }
}
